import React from "react";
import { useStaticData } from "../../../hooks/useStaticData";
import { SingleSelect, type SingleSelectProps } from "../SingleSelect";

// TODO - TEST STATIC

const BreedsSingle: React.FC<SingleSelectProps> = ({ ...props }) => {
	const { dogBreedNames: breeds } = useStaticData(["dogBreedNames"]);
	return (
		<SingleSelect
			key={breeds.length}
			{...props}
			nonSchemaOptions={breeds}
			value=""
		/>
	);
};

export default BreedsSingle;

// const BREEDS_QUERY = graphql`
//     query AllBreedNames {
//         allTaxonomyTermBreed {
//             nodes {
//                 name
//             }
//         }
//     }
// `;
